import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { masterListingConfig } from "@/lib/datasetRegistry"

// Thin config module — the whole page is the parameterized <DatasetUploadsPage>
// driven by `masterListingConfig` (app/frontend/lib/datasetRegistry.ts). Controller
// renders this via inertia page name "admin/master_listing/Uploads".
export default function AdminMasterListingUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={masterListingConfig} {...props} />
}
